/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.17.10.0 (NJsonSchema v9.10.49.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpResponseBase, HttpErrorResponse } from '@angular/common/http';
export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');
import { AppConsts } from 'shared/AppConsts';
@Injectable()
export class FileUploadSendEmailService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;
    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
        if(this.baseUrl==""){
            this.baseUrl = AppConsts.remoteServiceBaseUrl;
        }
    }
    /**
     * @model (optional) 
     * @return Success
     */
    externalFileUploadSendEmail(email : any,subject: any,msg: any,location: any,screenshot: any,copy: any,file: any,imgFile: any,username: any,emailtype: any): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/Profile/FileUploadSendEmail";
        url_ = url_.replace(/[?&]$/, "");
        let formData: FormData = new FormData();
        formData.append('ImageFile', imgFile);
        if(file){
            formData.append('Files', file, file.name);
        }
        else 
        {
            formData.append('Files',null);
        }
        formData.append('email', email);
        formData.append('subject', subject);
        if(location) {
            formData.append('LocationofBug', location);
        }
        else {
            formData.append('LocationofBug', null);
        }
        formData.append('DescriptionOfTheBugOrQuestionOrMessage',msg);
        formData.append('IncludeScreenshotOfTheBrowser',screenshot);
        formData.append('SendCopy',copy);
        formData.append('UserName',username);
        formData.append('emailtype',emailtype);
        let headers = new Headers();
        headers.append('Content-Type', 'multipart/form-data');
        headers.append('Accept', 'application/json');
        // let options_: any = {
        //     observe: "response",
        //     responseType: "blob",
        //     headers: new HttpHeaders({
        //         "Content-Type": "multipart/form-data",
        //         "Accept": "application/json"
        //     })
        // };
        return this.http.post(url_, formData);
        //.pipe(_observableMergeMap((response_: any) => {
            //return this.processExternalFileUploadSendEmail(response_);
        //})).pipe(_observableCatch((response_: FileUploadSendEmailResult) => {
          //   if (response_ instanceof HttpResponseBase) {
            //     try {
            //         return this.processExternalFileUploadSendEmail(<any>response_);
            //     } catch (e) {
            //         return <Observable<FileUploadSendEmailResult>><any>_observableThrow(e);
            //     }
             //} else
               //  return <Observable<FileUploadSendEmailResult>><any>_observableThrow(response_);
        //}));
    }
    protected processExternalFileUploadSendEmail(response: HttpResponseBase): Observable<FileUploadSendEmailResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? FileUploadSendEmailResult.fromJS(resultData200) : new FileUploadSendEmailResult();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileUploadSendEmailResult>(<any>null);
    }
}
@Injectable()
export class FileUploadSendEmail implements IFileUploadSendEmail {
  SendCopy: boolean;
  email: string;
  subject: string;
  Files: string;
  Name:string;
  Copy:boolean;
  DescriptionOfTheBugOrQuestionOrMessage: string;
  IncludeScreenshotOfTheBrowser:boolean;
  emailtype:string;
    constructor(data?: IFileUploadSendEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }
    init(data?: any) {
        if (data) {
            this.email = data["email"];
            this.subject = data["subject"];
            this.Files = data["Files"];
            this.DescriptionOfTheBugOrQuestionOrMessage = data["DescriptionOfTheBugOrQuestionOrMessage"];
            this.IncludeScreenshotOfTheBrowser = data["IncludeScreenshotOfTheBrowser"];
            this.emailtype=data["emailtype"];
        }
    }
    static fromJS(data: any): FileUploadSendEmail {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadSendEmail();
        result.init(data);
        return result;
    }
    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["subject"] = this.subject;
        data["Files"] = this.Files;
        data["DescriptionOfTheBugOrQuestionOrMessage"] = this.DescriptionOfTheBugOrQuestionOrMessage;
        data["IncludeScreenshotOfTheBrowser"] = this.IncludeScreenshotOfTheBrowser;
        return data;
    }
}

export interface IFileUploadSendEmail {
  SendCopy: boolean;
  email: string;
  subject: string;
  Files: string;
  Name:string;
  Copy:boolean;
  DescriptionOfTheBugOrQuestionOrMessage: string;
  IncludeScreenshotOfTheBrowser: boolean;
}

export class FileUploadSendEmailResult implements IFileUploadSendEmailResult {
  Success: boolean | false;
  Error: string;
  constructor(data?: IFileUploadSendEmailResult) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }
  init(data?: any) {
      if (data) {
          this.Success = data["Success"];
          this.Error = data["Error"];
      }
  }
  static fromJS(data: any): FileUploadSendEmailResult {
      data = typeof data === 'object' ? data : {};
      let result = new FileUploadSendEmailResult();
      result.init(data);
      return result;
  }
  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["Success"] = this.Success;
      data["Error"] = this.Error;
      return data;
  }
}

export interface IFileUploadSendEmailResult {
    Success: boolean | false;
    Error: string;
}



export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;
    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = function () {
                observer.next(this.result);
                observer.complete();
            }
            reader.readAsText(blob);
        }
    });
}
